"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldOverrideBmContainsBehavior = exports.evaluate = void 0;
var shouldOverrideBmContainsBehavior = function (overriddenBehaviors, behaviorName) {
    return overriddenBehaviors ? behaviorName in overriddenBehaviors : false;
};
exports.shouldOverrideBmContainsBehavior = shouldOverrideBmContainsBehavior;
var evaluate = function (overriddenBehaviors, behaviorName) {
    if (shouldOverrideBmContainsBehavior(overriddenBehaviors, behaviorName)) {
        return overriddenBehaviors[behaviorName];
    }
    return false;
};
exports.evaluate = evaluate;
